import { SizeType } from '@config/type'
import cn from 'classnames'

import { Button } from '@components/button/button'

import styles from './close-btn.module.css'

type CloseBtnProps = {
  className?: string
  onClose: () => void
  size?: SizeType
  colored?: boolean
}

export const CloseBtn = ({
  className,
  onClose,
  size = 'sm',
  colored = false
}: CloseBtnProps) => {
  return (
    <Button
      className={cn(styles.container, className, {
        [styles.small]: size === 'sm',
        [styles.colored]: colored === true
      })}
      sizeType={size}
      appearance="transparent"
      onClick={onClose}
    >
      <span className={styles.icon}></span>
    </Button>
  )
}
